module.exports = __webpack_public_path__ + "img/iphones.2e586052.png";